<template>
    <div>
        <div class=" col-md-12 col-lg-12"
             v-for="(number, nIndex) in initialPhoneNumbers">
            <phone-number-selector-input :number="number"
                                         v-on:update="handleNumberUpdate(nIndex,$event)"
                                         v-on:remove="handleNumberRemove($event)"
            ></phone-number-selector-input>

        </div>
        <div class="col-sm-12">
            <base-button
                    size="sm"
                    icon
                    type="success"
                    @click="handleNumberAdd()"
            >
                <font-awesome-icon :icon="['fal','plus']"></font-awesome-icon>
            </base-button>
        </div>
    </div>
</template>

<script>
    import PhoneNumberSelectorInput from "./PhoneNumberSelectorInput";

    export default {
        name: "PhoneNumberSelector",
        components: {PhoneNumberSelectorInput},
        props: {
            initialPhoneNumbers: Array,
        },
        methods: {
            handleNumberUpdate(nIndex, event) {
                let number = event.number;
                this.$emit('update', {nIndex,number});
            },
            handleNumberRemove(event) {
                let number = event.number;
                this.$emit('remove', {number});
            },
            handleNumberAdd() {
                this.$emit('add');
            }
        },
    }
</script>

<style scoped>

</style>